import {APIService} from '@custom-types/APIService';
import {HttpRequest} from '@services/HttpClient';
import {APIServiceResponse} from '@custom-types/APIServiceResponse';
import {trackErrorEvents} from '@utils/googleAnalytics/googleAnalyticsEvents';
import {getAPIUrl} from '@utils/service.utils';
import { ImgProps } from '@custom-types/ImgProps';

type GUFSAPIResponse = APIServiceResponse<DataItemm[]>;

export interface UnitOptions {
    key: string,
    label: string,
}

export interface GSUResponseData {
    bedrooms: Bedroom[];
}

export interface Bedroom {
    key: string;
    count: number;
    images: string[];
}

export interface DataItemm {
    key: string;
    count: number;
    images: string[];
    unitTypes: {key: string, count: number}[];
};

export interface ResponseData {
    data: DataItemm[];
}


export interface Unit {
    key: string;
    url: string,
    bedRoom: string;
    bgImg: ImgProps;
    unitTypes: string;
    unitsAvailable: number;

}

export type GSUParsedData = {
    units: Unit[];
    options: UnitOptions[];
};

export type GUFSPayload = string | null;

export function getUnitsForSale(
  payload: GUFSPayload
): APIService<GSUParsedData> {
    const route = `search/property/v2/configuration?text=${payload}`;
    const httpRequest = new HttpRequest<GUFSAPIResponse>(getAPIUrl('search', route));
    return {
        send: async () => {
        try {
            const response = await httpRequest.send();
            return parsedResponse(response.data);
        } catch (err: any) {
            trackErrorEvents({
            type: 'get_unit_for_sale_fetch_failed',
            errorStack: err,
            });
            throw err;
        }
        },
        abort: httpRequest.abort,
    };
}

const getBedroomKey = (text: string) => {
    return text === 'Studio' ? 'studio' : `${text}bdr`;
}

const getOptionLabel = (text: string) => {
    return text === 'Studio' ? 'Studio' : `${text} BR`;
}

const getBedLabel = (text: string) => {
    return text === 'Studio' ? text : `${text} Bedroom${Number(text) > 1 ? 's' : ''}`;
}

const getUnitTypes = (types: {key: string; count: number;}[]) => {
    return types?.map((unitTypes) => (unitTypes.key)).join('/')
}

const parsedResponse = (data: DataItemm[])  => {
    const units = data?.map(unit => ({
            key: getBedroomKey(unit.key),
            url: `${unit.key}`,
            bedRoom: getBedLabel(unit.key) || '_',
            unitTypes: getUnitTypes(unit.unitTypes) || '_',
            bgImg: {
                src: unit.images[0],
                alt: 'No image found',
            },
            unitsAvailable: unit.count,
        }
    ));
    const options = data?.map(unit => ({
        key: getBedroomKey(unit.key),
        label: getOptionLabel(unit.key),
    }));
    return { units, options };
};
